import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperclip} from "@fortawesome/free-solid-svg-icons";

import {Abbr, Inline} from "../../style/components/general.js";
import {pad} from "../../style/components/variables.js";

export const AttachmentColumnHeader = () => (
  <Abbr title="Attachments">
    <AttachmentHeaderIcon icon={faPaperclip} />
  </Abbr>
);

export const AttachmentCell = ({count, onOpen}) => {
  if (!count) return "";

  return (
    <AttachmentButton type="button" title={`${count} row attachment(s)`} onClick={onOpen}>
      <AttachmentIcon>
        <FontAwesomeIcon icon={faPaperclip} />
        <p>{count}</p>
      </AttachmentIcon>
    </AttachmentButton>
  );
};

AttachmentCell.propTypes = {
  count: PropTypes.number.isRequired,
  onOpen: PropTypes.func.isRequired
};

const AttachmentHeaderIcon = styled(FontAwesomeIcon)`
  fill: ${({theme}) => theme.tertiary};
`;

const AttachmentButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
`;

const AttachmentIcon = styled(Inline)`
  flex-wrap: nowrap;
  color: ${({theme}) => theme.primary};
  width: min-content;
  margin-bottom: 2px;
  font-size: 14px;

  svg {
    pointer-events: none;
    fill: ${({theme}) => theme.primary};
    font-size: 14px;
  }

  p {
    margin-top: 1px;
    margin-left: ${pad / 2}px;
  }
`;
